/**
 * @file Reads a served JSON array cell, such as a project's salesperson ids or
 * its form list. Consumers: `analyticsProjects` and `analyticsProjectDetail`.
 * The cell reads as its items only when it is a string holding a JSON array
 * whose every item passes `isItem`; anything else is `undefined` (malformed),
 * never a partial list.
 */
import type { NamedQueryCell } from '#types';

export const analyticsJsonArray = <T>(
  cell: NamedQueryCell,
  isItem: (item: unknown) => item is T,
): readonly T[] | undefined => {
  if (typeof cell !== 'string') return undefined;
  try {
    const parsed: unknown = JSON.parse(cell);
    if (!Array.isArray(parsed)) return undefined;
    const items = parsed.filter(isItem);
    return items.length === parsed.length ? items : undefined;
  } catch {
    return undefined;
  }
};
